import { Modal } from "theme";

const DISMISSED_KEY = "theme:shop-switch-dismissed";
const COUNTRY_KEY = "theme:shop-switch-country";

// Butiksskifter: foreslår butikken der matcher den besøgendes land (Shopify geolokation, ingen API-nøgle)
var ShopSwitchModal = class extends Modal {
  connectedCallback() {
    super.connectedCallback();

    // Knapperne er skjult indtil modalen findes, så de ikke vises når sektionen er slået fra
    this.controls.forEach((control) => control.hidden = false);
    this.addEventListener("dialog:after-hide", () => this.#rememberDismissal(), { signal: this.abortController.signal });

    if (Shopify.designMode) {
      return;
    }

    const params = new URLSearchParams(window.location.search);

    if (params.has("shop_switch")) {
      // Kunden har selv valgt denne butik i en anden butiks skifter
      this.#rememberDismissal();
      params.delete("shop_switch");
      const query = params.toString();
      window.history.replaceState(window.history.state, "", `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`);
      return;
    }

    if (this.mode === "manual" || (this.mode === "auto" && this.#isDismissed())) {
      return;
    }

    this.#suggestStore();
  }

  get shouldAppendToBody() {
    return false;
  }

  get mode() {
    return this.getAttribute("mode") || "auto";
  }

  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }

  get dismissDays() {
    return parseInt(this.getAttribute("dismiss-days") || 30);
  }

  async #suggestStore() {
    const countryCode = await this.#detectCountry();

    if (!countryCode) {
      return;
    }

    const items = Array.from(this.querySelectorAll("[data-store-id]:not([data-hidden])"));
    const suggested = items.find((item) => item.getAttribute("data-countries").split(",").includes(countryCode)) || items.find((item) => item.hasAttribute("data-default"));

    if (!suggested || suggested.hasAttribute("data-current")) {
      return;
    }

    suggested.setAttribute("data-suggested", "");
    setTimeout(() => this.show(), this.apparitionDelay);
  }

  async #detectCountry() {
    try {
      const cached = sessionStorage.getItem(COUNTRY_KEY);

      if (cached) {
        return cached;
      }
    } catch (error) {}

    try {
      const response = await fetch("/browsing_context_suggestions.json?country%5Benabled%5D=true");
      const countryCode = (await response.json())?.detected_values?.country?.handle;

      if (countryCode) {
        sessionStorage.setItem(COUNTRY_KEY, countryCode);
      }

      return countryCode;
    } catch (error) {
      return null;
    }
  }

  #isDismissed() {
    try {
      return parseInt(localStorage.getItem(DISMISSED_KEY) || 0) > Date.now();
    } catch (error) {
      return false;
    }
  }

  #rememberDismissal() {
    if (this.mode === "test" || Shopify.designMode) {
      return;
    }

    try {
      localStorage.setItem(DISMISSED_KEY, String(Date.now() + this.dismissDays * 864e5));
    } catch (error) {}
  }
};

if (!window.customElements.get("shop-switch-modal")) {
  window.customElements.define("shop-switch-modal", ShopSwitchModal);
}
